<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current='page'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem labelString="商品" lab v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品搜索:</label>
            <lk-input placeholder='请输入商品名，通用名，商品编码，助记码' class="item" clearable v-model.trim="query.nameMix"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>单据号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.code"></lk-input>
          </div>
          <div class="queryItem">
            <label>业务类型:</label>
           <lk-select  class="item" multiple v-model='query.typeList' clearable>
                <lk-option :value='1'>销售订单</lk-option>
                <lk-option :value='2'>销售退货</lk-option>
           </lk-select>
          </div>

          <div class="queryItem">
            <label>创建日期:</label>
            <timeStampDatePicker clearable type='daterange' placeholder='请选择' class="item" v-model="query.duration"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>签收日期:</label>
            <timeStampDatePicker clearable type='daterange'  placeholder='请选择' class="item" v-model="query.durationReceive"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>生产厂家:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.producer"></lk-input>
          </div>
          <div class="queryItem">
            <label>采购来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for="(item,index) in getGoodsOrigin" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>订单来源:</label>
            <lk-select
            v-model='query.epSourceType'
            class="item"
            clearable
            @on-change='(val)=>{val===0&&(query.epCreatorType=null)}'>
              <lk-option
              v-for="(item,index) in sourceTypeList"
              :key="index"
              :value='item.id'>
              {{item.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>批次:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.batchSeq"></lk-input>
          </div>
          <div class="queryItem">
            <label>批号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.batchCode"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>

      <div slot="table">
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('equipmentDetailExcel')"></DownloadButton> &nbsp;
        <RetailSummaryInfo :data="summary" :showActivity='false'></RetailSummaryInfo>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import RetailSummaryInfo from './RetailSummaryInfo';
import sale from '../../services/sale';
import utils from '../../libs/utils';
// import system from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsService from '../../services/goods';
import DownloadButton from '../../components/download/DownloadButton';
import RetailDetailExpand from './RetailDetailExpand.vue';
import goodsTypeCascader from '../../components/goodsTypeCascader.vue';

export default {
  name: 'equipmentDetailQuery',
  mixins: [mapState, queryMixins],
  components: {
    DownloadButton,
    QueryFrame,
    RetailDetailExpand,
    RetailSummaryInfo,
    goodsTypeCascader,
  },
  computed: {
    ...mapGetters(['getGoodsOrigin']),
  },
  data() {
    return {
      offType: [{ value: 1, name: '统一结算' }, { value: 2, name: '自负成本' }],
      offValue: [{ value: 1, name: '有' }, { value: 2, name: '无' }],
      activity: [{ value: 1, name: '有' }, { value: 2, name: '无' }],
      gspList: [],
      storageConditionsList: [],
      sourceTypeList: [], // 订单来源
      summary: {},
      query: {
        epSourceType: null,
        storeIdList: [],
        duration: [],
        gspList: [],
        durationReceive: utils.lastMonthToNow(), // 签收日期
        typeList: [1, 2],
      },
      columns: [
        {
          type: 'expand',
          minWidth: 50,
          fixed: 'left',
          render: (h, params) => h(RetailDetailExpand,
            {
              props: {
                row: params.row,
                isEquipment: true,
                showRatify: false,
              },
            }),
        },
        {
          title: '门店名称', key: 'storeName', minWidth: 130,
        },
        {
          title: '创建日期', key: 'createTime', minWidth: 100, tooltip: true,
        },
        {
          title: '签收日期', key: 'receiptTime', minWidth: 100, tooltip: true,
        },
        {
          title: '业务类型', key: 'typeName', minWidth: 90, tooltip: true,
        },
        {
          title: '单据号', key: 'code', minWidth: 116,
        },
        {
          title: '订单来源', key: 'epSourceTypeName', minWidth: 90, tooltip: true,
        },
        {
          title: '商品编码',
          key: 'goodsInfoVoDrugSerialCode',
          minWidth: 90,
          tooltip: true,
        },
        {
          title: '商品名', key: 'goodsInfoVoGoodsName', minWidth: 90, tooltip: true,
        },
        {
          title: '通用名',
          key: 'goodsInfoVoApprovedDrugName',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '规格', key: 'goodsInfoVoSpec', minWidth: 116, tooltip: true,
        },
        {
          title: '生产厂家', key: 'goodsInfoVoProducer', minWidth: 140, tooltip: true,
        },
        {
          title: '单位', key: 'goodsInfoVoMinPkgUnitName', minWidth: 60, tooltip: true,
        },
        {
          title: '零售数量',
          key: 'num',
          minWidth: 90,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('num') >= 0 ? row.num : '/'),
        },
        {
          title: '实际单价',
          key: 'realPrice',
          minWidth: 90,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('realPrice') >= 0 ? row.realPrice : '/'),
        },
        {
          title: '销售单价',
          key: 'retailPrice',
          minWidth: 90,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('retailPrice') >= 0 ? row.retailPrice : '/'),
        },
        {
          title: '折扣金额',
          key: 'discountDisplay',
          minWidth: 90,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('discountDisplay') >= 0 ? row.discountDisplay : '/'),
        },
        {
          title: '含税零售额',
          key: 'amountDisplay',
          minWidth: 110,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('amountDisplay') >= 0 ? row.amountDisplay : '/'),
        },
        {
          title: '不含税零售额',
          key: 'amountWithoutTax',
          minWidth: 120,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('amountWithoutTax') >= 0 ? row.amountWithoutTax : '/'),
        },
        {
          title: '销项税率',
          key: 'taxRate',
          minWidth: 90,
          tooltip: true,
          // render: (h, { row }) => h('span', Object.keys(row).indexOf('taxRate') >= 0 ? row.taxRate : '/'),
        },
        {
          title: '零售税额',
          key: 'totalTax',
          minWidth: 110,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('totalTax') >= 0 ? row.totalTax : '/'),
        },
        {
          title: '含税成本',
          key: 'costAmountDisplay',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '不含税成本',
          key: 'costAmountWithoutTax',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '进项税率',
          key: 'inputTaxRate',
          minWidth: 90,
          tooltip: true,
        },
        { // 新增
          title: '成本税额',
          key: 'totalCostTax',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '含税毛利',
          key: 'profitAmount',
          minWidth: 110,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('profitAmount') >= 0 ? row.profitAmount : '/'),
        },
        {
          title: '不含税毛利',
          key: 'profitAmountWithoutTax',
          minWidth: 110,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('profitAmountWithoutTax') >= 0 ? row.profitAmountWithoutTax : '/'),
        },
        {
          title: '含税毛利率',
          key: 'profitRate',
          minWidth: 100,
          tooltip: true,
          // render: (h, { row }) => h('span', Object.keys(row).indexOf('profitRate') >= 0 ? row.profitRate : '/'),
        },
        {
          title: '不含税毛利率',
          key: 'profitRateWithoutTax',
          minWidth: 110,
          tooltip: true,
          render: (h, { row }) => h('span', Object.keys(row).indexOf('profitRateWithoutTax') >= 0 ? row.profitRateWithoutTax : '/'),
        },
        {
          title: '批次', key: 'inventoryInfoGoodsBatchSeq', minWidth: 120,
        },
        {
          title: '批号', key: 'inventoryInfoGoodsBatchNumber', minWidth: 120,
        },
        {
          title: '生产日期',
          key: 'inventoryInfoGoodsProductionDate',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '有效期至',
          key: 'inventoryInfoGoodsExpiryDate',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '收/退款方式',
          key: 'proceedsTypeString',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '已退货数量',
          key: 'refundNum',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '含税退货金额',
          key: 'refundAmount',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '不含税退货金额',
          key: 'refundAmountWithoutTax',
          minWidth: 120,
          tooltip: true,
        },
      ],
      tableData: [],
      types: [],
      bool: ['是', '否'],
      gender: ['男', '女'],
    };
  },
  methods: {
    clear() {
      this.query = {

        storeIdList: [],
        duration: [],
        gspList: [],
        durationReceive: []
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.isRx = 1;
      this.params.createTimeStart = this.params.duration[0];
      this.params.createTimeEnd = this.params.duration[1];
      if (this.params.durationReceive && this.params.durationReceive.length) {
        this.params.receiptStartTime = this.params.durationReceive[0];
        this.params.receiptEndTime = this.params.durationReceive[1];
      }
      // reportType  报表类型 1：器械销售明细 2：饮片销售明细 3：含麻黄碱销售记录 4：处方药销售记录  空：零售明细
      this.params.reportType = 1;
      this.getDetailSummary();
      sale
        .getListRetailReport(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            this.count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              result.createTime = utils.formatDate(result.createTime);
              result.receiptTime = result.receiptTime ? utils.formatDate(result.receiptTime) : ''; //签收日期
              result.inventoryInfoGoodsProductionDate = utils.formatDate(result.inventoryInfoGoodsProductionDate);
              result.inventoryInfoGoodsExpiryDate = utils.formatDate(result.inventoryInfoGoodsExpiryDate);
              result.goodsInfoVoIsDtp = this.bool[result.goodsInfoVoIsDtp - 1];
              result.goodsInfoVoIsPrescriptionDrug = this.bool[result.goodsInfoVoIsPrescriptionDrug - 1];
              result.goodsInfoVoIsEphedrineDrugs = this.bool[result.goodsInfoVoIsEphedrineDrugs - 1];
              Object.keys(result).indexOf('profitRate') >= 0 ? result.profitRate += '%' : result.profitRate = '/';
              Object.keys(result).indexOf('taxRate') >= 0 ? result.taxRate += '%' : result.taxRate = '/';// 销项税率
              Object.keys(result).indexOf('profitRateWithoutTax') >= 0 ? result.profitRateWithoutTax += '%' : result.profitRateWithoutTax = '/';
              Object.keys(result).indexOf('inputTaxRate') >= 0 ? result.inputTaxRate += '%' : result.inputTaxRate = '/';
              result.inventoryRecordTaxRate !== undefined
                ? result.inventoryRecordTaxRate += '%'
                : null;


              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getDetailSummary() {
      sale.getRetailDetailSummary(this.params).then((res) => {
        if (res.data.status === 200) {
          this.summary = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    download() {
      const params = utils.deepClone(this.query);
      if (params.durationReceive && params.durationReceive.length) {
        params.receiptStartTime = params.durationReceive[0];
        params.receiptEndTime = params.durationReceive[1];
      }
      params.createTimeStart = params.duration[0];
      params.createTimeEnd = params.duration[1];
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      params.reportType = 1;
      sale.downloadListRetailReport(params).then((res) => {
        // utils.downLoadExcel(res, '器械销售明细查询');
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    exportDrugFlow() {
      const params = utils.deepClone(this.query);
      params.page = 0;
      params.size = 0;
      params.createTimeStart = params.duration[0];
      params.createTimeEnd = params.duration[1];
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      if (this.params.durationReceive && this.params.durationReceive.length) {
        this.params.receiptStartTime = this.params.durationReceive[0];
        this.params.receiptEndTime = this.params.durationReceive[1];
      }
      sale.exportDrugFlow(params).then((res) => {
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStorageConditionsList() {
      goodsService.GoodsDictionary({ dictionaryTypeEnum: 9 }).then((res) => {
        if (res.data.status === 200) {
          this.storageConditionsList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getGSPList() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.gspList = res.data.data.list;// .filter(item => item.name.includes('RX'));
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 订单来源类型
    getListSourceType() {
      return new Promise((resolve, reject) => {
        sale.getListSourceType().then((res) => {
          if (res.data.status === 200) {
            this.sourceTypeList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
            reject(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
  },
  created() {
    this.getStorageConditionsList();
    this.getGSPList();
  },
  mounted() {
    this.getListSourceType().then(() => {
      this.handleSearch(true);
    });
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-table-wrapper {
  .ivu-table {
    line-height: 15px !important;
    th {
      height: auto;
      padding: 10px 0;
    }
    td {
      padding: 5px 0;
      height: auto;
    }
    .ivu-table-cell {
      .ivu-btn {
        line-height: 0.6;
      }
    }
    .ivu-table-tip table td {
      height: 40px;
    }
  }
}
</style>
